module.exports = __webpack_public_path__ + "static/media/soup.687ead1c.png";